// de德语
export default {
    CustomSelect: {
        '请选择': 'Auswählen',
    },
    TopNav: {
        '创作者': 'Ersteller',
        '游客': 'Gast',
        '请登录后体验完整功能': 'Bitte anmelden für volle Funktionalität',
        '登录': 'Anmelden',
        '免费试用': 'Kostenlos testen',
        '退出登录': 'Abmelden',
        '个人中心': 'Mein Konto',
        '我的视频': 'Meine Videos',
        '额度管理': 'Kontingentverwaltung',
        '首页': 'Startseite',
        'AI创作': 'KI-Erstellung',
        '多参考': 'Mehrfachreferenz',
        '文本视频': 'Text zu Video',
        '图片视频': 'Bild zu Video',
        '文生图': 'Text zu Bild',
        '图生图': 'Bild zu Bild',
        '会员中心': 'Mitgliederbereich',
        '概览': 'Übersicht',
        '我的创作': 'Meine Kreationen',
        '账单管理': 'Abrechnungsverwaltung',
        '生成任务': 'Generierungsaufgaben',
        '价格': 'Preise',
        '新闻资讯': 'Neuigkeiten',
        '确定要退出登录吗？': 'Möchten Sie sich abmelden?',
        '提示': 'Hinweis',
        '确定': 'Bestätigen',
        '取消': 'Abbrechen',
        '退出成功': 'Erfolgreich abgemeldet',
        '视频展示': 'Videoanzeige'
    },
    AiLayout: {
        'AI创作中心': 'KI-Erstellungszentrum',
        '视频生成': 'Video-Generierung',
        '图片生成': 'Bild-Generierung',
        '我的作品': 'Meine Werke',
        '我的创作': 'Meine Kreationen',
        '今日剩余额度': 'Heutiges Restkontingent',
        '多参考': 'Mehrfachreferenz',
        '文本视频': 'Text zu Video',
        '图片视频': 'Bild zu Video',
        '文生图': 'Text zu Bild',
        '图生图': 'Bild zu Bild',
    },
    HomeLayout: {
        '下一代AI视频生成平台': 'Nächste Generation KI-Video-Generierungsplattform, verwandelt Ideen sofort in Realität',
        '产品': 'Produkte',
        'AI视频': 'KI-Video',
        '价格方案': 'Preispläne',
        '新闻资讯': 'Neuigkeiten',
        '支持': 'Support',
        '帮助中心': 'Hilfezentrum',
        'API文档': 'API-Dokumentation',
        '常见问题': 'Häufige Fragen',
        '法律': 'Rechtliches',
        '服务条款': 'Nutzungsbedingungen',
        '隐私政策': 'Datenschutzrichtlinie',
        '使用协议': 'Vereinbarung zur Nutzung',
        '版权所有': 'Alle Rechte vorbehalten',
        '客服邮箱': 'Support-E-Mail',
        '复制邮箱': 'E-Mail kopieren',
        '开发中': 'In Entwicklung, bleiben Sie dran!',
        '链接已复制到剪贴板': 'Link in die Zwischenablage kopiert',
    },
    MyLayout: {
        '创作者': 'Ersteller',
        '退出登录': 'Abmelden',
        '概览': 'Übersicht',
        '我的创作': 'Meine Kreationen',
        '会员中心': 'Mitgliederbereich',
        '额度管理': 'Kontingentverwaltung',
        '账单管理': 'Abrechnungsverwaltung',
        '生成任务': 'Generierungsaufgaben',
        '确定要退出登录吗？': 'Möchten Sie sich abmelden?',
        '提示': 'Hinweis',
        '确定': 'Bestätigen',
        '取消': 'Abbrechen',
        '退出成功': 'Erfolgreich abgemeldet'
    },
    Image: {
        "文本生成图片": "Text zu Bild",
        "图片生成图片": "Bild zu Bild",
        "用文字描述": "Beschreiben Sie mit Worten, was Sie sich wünschen",
        "上传图片素材": "Bildmaterial hochladen, unterstützt Mehrfachgenerierung",
        "图片描述": "Bildbeschreibung",
        "描述您想要的图片": "Beschreiben Sie detailliert den Inhalt des gewünschten Bildes, unterstützt Deutsch oder Englisch...",
        "提示描述越详细效果越好": "Hinweis: Je detaillierter die Beschreibung, desto besser das Generierungsergebnis",
        "图片素材": "Bildmaterial",
        "预览图片": "Vorschau",
        "上传图片": "Bild hochladen",
        "支持格式JPGPNG": "Unterstützt JPG-, PNG-Formate",
        "最多": "Maximal",
        "张图片": "Bild(er)",
        "超过大小限制": "Überschreitet das 10-MB-Limit",
        "不是图片文件": "Ungültige Bilddatei",
        "最多上传": "Maximal hochladbar",
        "请先上传图片": "Bitte zuerst Bildmaterial hochladen",
        "请选择要生成的图片": "Bitte wählen Sie das zu generierende Bild aus",
        "生成结果": "Generierungsergebnis",
        "重新生成成功": "Erfolgreich neu generiert",
        "模型": "KI-Modell",
        "请选择模型": "Bitte wählen Sie das Generierungsmodell",
        "分辨率": "Ausgabeauflösung",
        "请选择分辨率": "Bitte wählen Sie die Auflösung",
        "图片比例": "Bildseitenverhältnis",
        "补充描述": "Zusätzliche Beschreibung (optional)",
        "补充描述提示": "Optional: Beschreiben Sie zusätzliche Effekte oder Stile, die das Bild haben soll",
        "开始绘制": "Zeichnen beginnen",
        "开始生成": "Generierung beginnen",
        "生成中": "Generierung läuft, bitte warten...",
        "生成成功": "Generierung erfolgreich",
        "图片生成成功": "Bild erfolgreich generiert!",
        "作品已保存到我的作品": "Werk wurde in 'Meine Werke' gespeichert",
        "继续创作": "Weiter erstellen",
        "查看作品": "Werk ansehen",
        "请输入图片描述": "Bitte geben Sie eine Bildbeschreibung ein"
    },
    MyCreation: {
        '我的创作': 'Meine Kreationen',
        '查看和管理您的所有作品': 'Alle Ihre Werke anzeigen und verwalten',
        '预览': 'Vorschau',
        '下载': 'Herunterladen',
        '编辑': 'Bearbeiten',
        '分享': 'Teilen',
        '删除': 'Löschen',
        '暂无作品': 'Keine Werke',
        '去创作': 'Erstellen gehen',
        '确定删除': 'Löschen bestätigen',
        '确定要删除作品': 'Möchten Sie das Werk löschen',
        '吗？': '?',
        '此操作不可恢复': 'Diese Aktion kann nicht rückgängig gemacht werden, bitte vorsichtig sein!',
        '取消': 'Abbrechen',
        '分享作品': 'Werk teilen',
        '复制链接': 'Link kopieren',
        '全部': 'Alle',
        '视频': 'Video',
        '图片': 'Bild',
        '正在下载:': 'Herunterladen: ',
        '链接已复制到剪贴板': 'Link in die Zwischenablage kopiert',
        '删除成功': 'Erfolgreich gelöscht'
    },
    Video: {
        "文本生成视频": "Text zu Video",
        "图片生成视频": "Bild zu Video",
        "智能视频生成": "Intelligente Videogenerierung",
        "输入文字描述": "Textbeschreibung eingeben",
        "上传1-9张图片": "1-9 Bilder hochladen",
        "上传图片视频音频": "Bild/Video/Audio hochladen",
        "视频描述": "Videobeschreibung",
        "描述您想要的视频场景": "Beschreiben Sie die gewünschte Videoszene",
        "提示": "Hinweis",
        "图片素材": "Bildmaterial",
        "最多上传": "Maximal hochladen",
        "张": "Bild(er)",
        "预览": "Vorschau",
        "上传图片": "Bild hochladen",
        "支持格式": "Unterstützt JPG-, PNG-Formate, einzelne Datei max. 10 MB, maximal",
        "AI": "KI integriert intelligent und erzeugt flüssige Übergangseffekte",
        "动态描述": "Bewegungsbeschreibung",
        "描述您希望图片如何动起来": "Beschreiben Sie, wie sich das Bild bewegen soll",
        "个": "Stück",
        "上传视频": "Video hochladen",
        "上传音频": "Audio hochladen",
        "描述您希望视频呈现的效果": "Beschreiben Sie den gewünschten Videoeffekt",
        "模型": "Modell",
        "请选择模型": "Bitte wählen Sie das Modell",
        "分辨率": "Auflösung",
        "请选择分辨率": "Bitte wählen Sie die Auflösung",
        "宽高比": "Seitenverhältnis",
        "视频时长": "Videodauer",
        "生成音频": "Audio generieren",
        "开启音效": "Soundeffekte aktivieren",
        "静音模式": "Stummmodus",
        "音频提示": "Hinweis: Hochgeladenes Audio wird als Hintergrundmusik verwendet. Wenn kein Audio hochgeladen wird, generiert KI automatisch Musik",
        "开始生成": "Generierung beginnen",
        "积分": "Punkte",
        "生成中": "Generierung läuft",
        "生成成功": "Generierung erfolgreich",
        "视频生成成功！": "Video erfolgreich generiert!",
        "作品已保存到": "Werk wurde in 'Meine Werke' gespeichert",
        "继续创作": "Weiter erstellen",
        "查看作品": "Werk ansehen",
        "视频预览": "Videovorschau",
        "关闭": "Schließen",
        "下载视频": "Video herunterladen",
        "您的浏览器不支持视频播放": "Ihr Browser unterstützt keine Videowiedergabe",
        "生成进度": "Generierungsfortschritt",
        "描述": "Beschreibung",
        "时长": "Dauer",
        "秒": "Sekunden",
        "视频素材": "Videomaterial",
        "音频素材": "Audiomaterial",
        "双图融合模式": "Dualbild-Fusionsmodus",
        "开始下载视频": "Video herunterladen beginnen",
        "请输入视频描述": "Bitte geben Sie eine Videobeschreibung ein",
        "请至少上传一张图片": "Bitte laden Sie mindestens ein Bild hoch",
        "请至少上传一张图片或一个视频": "Bitte laden Sie mindestens ein Bild oder ein Video hoch",
        "最多只能上传": "Maximal hochladbar",
        "超过": "Überschreitet",
        "限制": "Limit",
        "不是图片文件": "Ungültige Bilddatei",
        "不是视频文件": "Ungültige Videodatei",
        "不是音频文件": "Ungültige Audiodatei"
    },
    Forgot: {
        "找回密码": "Passwort wiederherstellen",
        "请输入您的邮箱，我们将发送验证码": "Bitte geben Sie Ihre E-Mail ein, wir senden einen Bestätigungscode",
        "密码重置成功，请使用新密码登录": "Passwort erfolgreich zurückgesetzt, bitte melden Sie sich mit dem neuen Passwort an",
        "密码重置成功": "Passwort erfolgreich zurückgesetzt",
        "您的密码已成功重置，请使用新密码登录": "Ihr Passwort wurde erfolgreich zurückgesetzt, bitte melden Sie sich mit Ihrem neuen Passwort an",
        "立即登录": "Jetzt anmelden",
        "邮箱": "E-Mail",
        "请输入注册邮箱": "Bitte geben Sie die registrierte E-Mail ein",
        "发送验证码": "Bestätigungscode senden",
        "请输入验证码": "Bitte geben Sie den Bestätigungscode ein",
        "验证码": "Bestätigungscode",
        "新密码": "Neues Passwort",
        "设置新密码": "Neues Passwort festlegen",
        "确认新密码": "Neues Passwort bestätigen",
        "再次输入新密码": "Neues Passwort erneut eingeben",
        "重置密码": "Passwort zurücksetzen",
        "返回登录": "Zurück zur Anmeldung",
        "验证中": "Wird verifiziert",
        "重置中": "Wird zurückgesetzt",
        "弱": "Schwach",
        "中": "Mittel",
        "强": "Stark",
        "请输入邮箱地址": "Bitte E-Mail-Adresse eingeben",
        "请输入正确的邮箱格式": "Bitte geben Sie ein gültiges E-Mail-Format ein",
        "验证码应为6位数字": "Der Bestätigungscode sollte 6 Ziffern haben",
        "请输入新密码": "Bitte geben Sie ein neues Passwort ein",
        "密码至少需要6位": "Das Passwort muss mindestens 6 Zeichen lang sein",
        "请再次输入新密码": "Bitte geben Sie das neue Passwort erneut ein",
        "两次输入的密码不一致": "Die eingegebenen Passwörter stimmen nicht überein",
        "验证码已发送": "Bestätigungscode gesendet"
    },
    Login: {
        "下一代AI视频生成平台": "Nächste Generation KI-Video-Generierungsplattform",
        "一键生成": "Ein-Klick-Generierung",
        "支持4K超高清输出": "Unterstützt 4K Ultra-HD-Ausgabe",
        "多种风格模板任选": "Wählen Sie aus vielen Stilvorlagen",
        "商用授权无忧使用": "Kommerzielle Lizenz zur sorgenfreien Nutzung",
        "欢迎回来": "Willkommen zurück",
        "登录您的账号继续创作": "Melden Sie sich an, um weiter zu erstellen",
        "邮箱": "E-Mail",
        "请输入邮箱地址": "Bitte E-Mail-Adresse eingeben",
        "密码": "Passwort",
        "请输入您的密码": "Bitte geben Sie Ihr Passwort ein",
        "记住我": "Angemeldet bleiben",
        "忘记密码？": "Passwort vergessen?",
        "登录": "Anmelden",
        "登录中": "Anmeldung läuft",
        "还没有账号？": "Noch kein Konto?",
        "立即注册": "Jetzt registrieren",
        "请输入正确的邮箱格式": "Bitte geben Sie ein gültiges E-Mail-Format ein",
        "请输入密码": "Bitte geben Sie das Passwort ein",
        "密码至少需要6位": "Das Passwort muss mindestens 6 Zeichen lang sein",
        "密码不能超过20位": "Das Passwort darf maximal 20 Zeichen lang sein",
        "登录成功": "Erfolgreich angemeldet"
    },
    Register: {
        "创建账号": "Konto erstellen",
        "开始您的AI视频创作之旅": "Beginnen Sie Ihre Reise der KI-Videoerstellung",
        "姓名": "Name",
        "请输入您的姓名": "Bitte geben Sie Ihren Namen ein",
        "邮箱": "E-Mail",
        "请输入邮箱地址": "Bitte E-Mail-Adresse eingeben",
        "获取验证码": "Bestätigungscode anfordern",
        "验证码": "Bestätigungscode",
        "请输入验证码": "Bitte geben Sie den Bestätigungscode ein",
        "密码": "Passwort",
        "设置密码": "Passwort festlegen",
        "确认密码": "Passwort bestätigen",
        "再次输入密码": "Passwort erneut eingeben",
        "我已阅读并同意": "Ich habe gelesen und stimme zu",
        "服务条款": "Nutzungsbedingungen",
        "和": "und",
        "隐私政策": "Datenschutzrichtlinie",
        "注册中": "Registrierung läuft",
        "已有账号？": "Bereits ein Konto?",
        "立即登录": "Jetzt anmelden",
        "弱": "Schwach",
        "中": "Mittel",
        "强": "Stark",
        "请输入姓名": "Bitte geben Sie den Namen ein",
        "姓名至少需要2个字符": "Der Name muss mindestens 2 Zeichen lang sein",
        "姓名不能超过20个字符": "Der Name darf maximal 20 Zeichen lang sein",
        "请输入正确的邮箱格式": "Bitte geben Sie ein gültiges E-Mail-Format ein",
        "验证码应为6位数字": "Der Bestätigungscode sollte 6 Ziffern haben",
        "请输入密码": "Bitte geben Sie das Passwort ein",
        "密码至少需要6位": "Das Passwort muss mindestens 6 Zeichen lang sein",
        "密码不能超过20位": "Das Passwort darf maximal 20 Zeichen lang sein",
        "请再次输入密码": "Bitte geben Sie das Passwort erneut ein",
        "两次输入的密码不一致": "Die eingegebenen Passwörter stimmen nicht überein",
        "验证码已发送": "Bestätigungscode gesendet",
        "注册成功": "Erfolgreich registriert"
    },
    Faq: {
        '常见问题': 'Häufig gestellte Fragen',
        '您在使用过程中遇到的问题': 'Probleme, auf die Sie bei der Nutzung stoßen, finden Sie hier Antworten',
        '搜索您的问题': 'Suchen Sie nach Ihrer Frage...',
        '没有找到相关的问题': 'Keine verwandten Fragen gefunden',
        '查看全部问题': 'Alle Fragen anzeigen',
        '没有找到您想要的答案？': 'Haben Sie nicht die gewünschte Antwort gefunden?',
        '我们的客服团队随时为您提供帮助': 'Unser Support-Team steht Ihnen jederzeit zur Verfügung',
        '复制客服邮箱': 'Support-E-Mail kopieren',
        '链接已复制到剪贴板': 'Link in die Zwischenablage kopiert'
    },
    Home: {
        '立即订阅': 'Jetzt abonnieren',
        'AI视频生成新时代': 'Neue Ära der KI-Video-Generierung',
        '用文字创造': 'Mit Worten erschaffen',
        '无限视频': 'Unbegrenzte Videos',
        '让每个人都能成为视频创作者': 'Jeder kann ein Video-Ersteller werden. Geben Sie einfach eine Textbeschreibung ein, um hochwertige, einzigartige KI-Videos zu erhalten.',
        '免费开始': 'Kostenlos beginnen',
        '观看演示': 'Demo ansehen',
        'AI生成': 'KI-Generierung',
        'AI视频': 'KI-Video',
        '三步轻松生成专业视频': 'In drei Schritten einfach professionelle Videos generieren',
        '输入提示词': 'Eingabeaufforderung eingeben',
        '用文字描述您想要的视频内容': 'Beschreiben Sie den gewünschten Videoinhalt mit Worten, je detaillierter, desto besser',
        '智能生成': 'Intelligente Generierung',
        'AI模型自动理解并创作': 'KI-Modell versteht und erstellt automatisch, Rendering in wenigen Minuten abgeschlossen',
        '下载作品': 'Werk herunterladen',
        '高清视频生成完成': 'HD-Video generierung abgeschlossen, sofort herunterladbar und nutzbar',
        'AI视频生成': 'KI-Video-Generierung',
        '精彩视频': 'Geben Sie eine Textbeschreibung ein, und die KI generiert ein hervorragendes Video für Sie',
        '描述您想要的视频场景': 'Beschreiben Sie die gewünschte Videoszene, zum Beispiel: Eine Katze spielt unter einem Kirschblütenbaum, Sonnenlicht fällt durch die Blütenblätter...',
        '生成中': 'Generierung läuft...',
        '生成视频': 'Video generieren',
        'AI图片': 'KI-Bild',
        '精美图片': 'Geben Sie eine Textbeschreibung ein, und die KI generiert ein hervorragendes Bild für Sie',
        '描述您想要的图片场景': 'Beschreiben Sie die gewünschte Bildszene, zum Beispiel: Skyline einer Zukunftstadt, blinkende Neonlichter, Cyberpunk-Stil...',
        '生成图片': 'Bild generieren',
        '强大功能': 'Leistungsstarke Funktionen',
        '让视频创作变得简单有趣': 'Machen Sie die Videoerstellung einfach und unterhaltsam',
        '案例展示': 'Beispielpräsentation',
        '来看看用户使用': 'Sehen Sie sich die hervorragenden Werke an, die',
        '创作的精彩作品': 'Benutzer erstellt haben',
        '新闻资讯': 'Neuigkeiten',
        '了解': 'Entdecken Sie',
        '的最新动态和产品更新': 'die neuesten Nachrichten und Produktaktualisierungen',
        '查看更多': 'Mehr anzeigen',
        '热门': 'Beliebt',
        '最新': 'Neueste',
        '阅读更多': 'Mehr lesen',
        '选择适合您的方案': 'Wählen Sie den passenden Plan für sich',
        '灵活的定价': 'Flexible Preise für unterschiedliche Anforderungen',
        '视频预览': 'Videovorschau',
        '生成成功': 'Generierung erfolgreich',
        '作品已保存到': "Werk wurde in 'Meine Kreationen' gespeichert",
        '继续创作': 'Weiter erstellen',
        '查看作品': 'Werk ansehen',
        '请输入视频描述': 'Bitte geben Sie eine Videobeschreibung ein',
        '视频生成成功！': 'Video erfolgreich generiert!',
        '请输入图片描述': 'Bitte geben Sie eine Bildbeschreibung ein',
        '图片生成成功！': 'Bild erfolgreich generiert!',
    },
    News: {
        '新闻资讯': 'Neuigkeiten',
        '了解': 'Entdecken Sie',
        '的最新动态和产品更新': 'die neuesten Nachrichten und Produktaktualisierungen',
        '精选': 'Ausgewählt',
        '阅读': 'Lesen',
        '点赞': 'Gefällt mir',
        '热门': 'Beliebt',
        '最新': 'Neueste',
        '阅读更多': 'Mehr lesen',
        '加载中': 'Laden...',
        '暂无新闻': 'Keine Neuigkeiten',
        '清除筛选': 'Filter löschen',
        '加载新闻失败': 'Fehler beim Laden der Neuigkeiten, bitte später erneut versuchen',
    },
    Price: {
        '选择适合您的方案': 'Wählen Sie den passenden Plan für sich',
        '灵活的定价': 'Flexible Preise für unterschiedliche Anforderungen',
        '包月': 'Monatlich',
        '包年': 'Jährlich',
        '购买积分': 'Punkte kaufen',
        '只需要几个视频': 'Brauchen Sie nur ein paar Videos? Kein Abonnement nötig, kaufen Sie direkt ein Punktepaket',
        '产品大全': 'Produktkatalog',
        '了解': 'Entdecken Sie',
        '全系列产品的详细信息和支付方式': 'detaillierte Informationen und Zahlungsmethoden für die gesamte Produktpalette'
    },
    Billing: {
        '账单管理': 'Abrechnungsverwaltung',
        '账户余额': 'Kontostand',
        '本月支出': 'Ausgaben diesen Monat',
        '订单数量': 'Anzahl der Bestellungen',
        '账单列表': 'Rechnungsliste',
        '请选择类型': 'Bitte wählen Sie einen Typ',
        '请选择时间范围': 'Bitte wählen Sie einen Zeitraum',
        '订单号': 'Bestellnummer',
        '类型': 'Typ',
        '金额': 'Betrag',
        '状态': 'Status',
        '时间': 'Zeit',
        '操作': 'Aktion',
        '查看详情': 'Details anzeigen',
        '下载发票': 'Rechnung herunterladen',
        '暂无作品': 'Keine Werke',
        '去创作': 'Erstellen gehen',
        '支付方式': 'Zahlungsmethode',
        '添加支付方式': 'Zahlungsmethode hinzufügen',
        '默认': 'Standard',
        '设为默认': 'Als Standard festlegen',
        '编辑': 'Bearbeiten',
        '删除': 'Löschen',
        '账单详情': 'Rechnungsdetails',
        '交易流水号': 'Transaktionsnummer',
        '关闭': 'Schließen',
        '账号': 'Konto/Kartennummer',
        '请输入账号或卡号': 'Bitte geben Sie die Konto- oder Kartennummer ein',
        '姓名': 'Name',
        '请输入持卡人姓名': 'Bitte geben Sie den Namen des Karteninhabers ein',
        '有效期': 'Gültig bis',
        '请输入CVV码': 'Bitte geben Sie den CVV-Code ein',
        '取消': 'Abbrechen',
        '确认添加': 'Hinzufügen bestätigen',
        '确认修改': 'Änderung bestätigen',
        '确认删除': 'Löschen bestätigen',
        '编辑支付方式': 'Zahlungsmethode bearbeiten',
        '确定要删除支付方式': 'Möchten Sie diese Zahlungsmethode löschen',
        '删除后不可恢复': 'Das Löschen kann nicht rückgängig gemacht werden, bitte vorsichtig sein!',
        '请输入账号': 'Bitte geben Sie die Konto-/Kartennummer ein',
        '添加成功': 'Erfolgreich hinzugefügt',
        '修改成功': 'Erfolgreich geändert',
        '已设为默认支付方式': 'Wurde als Standardzahlungsmethode festgelegt',
        '删除成功': 'Erfolgreich gelöscht',
    },
    Credit: {
        '额度管理': 'Kontingentverwaltung',
        '当前可用额度': 'Derzeit verfügbares Kontingent',
        '升级会员': 'Mitgliedschaft upgraden',
        '本月已用': 'Diesen Monat genutzt',
        '视频生成': 'Video-Generierung',
        'AI图片': 'KI-Bild',
        '其他': 'Andere',
        '购买额度包': 'Kontingentpaket kaufen',
        '最受欢迎': 'Am beliebtesten',
        '额度': 'Kontingent',
        '立即购买': 'Jetzt kaufen',
        '使用记录': 'Nutzungsverlauf',
        '操作': 'Aktion',
        '类型': 'Typ',
        '额度变动': 'Kontingentänderung',
        '时间': 'Zeit',
        '购买': 'Kaufen',
        '确认购买': 'Kauf bestätigen',
        '金额': 'Betrag: ',
        '获得': 'Erhalten',
        '取消': 'Abbrechen',
        '今天': 'Heute',
        '昨天': 'Gestern',
    },
    Dashboard: {
        '欢迎回来': 'Willkommen zurück,',
        '创建新视频': 'Neues Video erstellen',
        '本月生成次数': 'Anzahl der Generierungen diesen Monat',
        '剩余额度': 'Restkontingent',
        '总视频数': 'Gesamtzahl der Videos',
        '会员状态': 'Mitgliedschaftsstatus',
        '最近生成': 'Letzte Generierungen',
        '查看全部': 'Alle anzeigen',
        '视频预览': 'Videovorschau',
        '视频生成中': 'Video wird generiert, bitte später zur Vorschau',
    },
    Membership: {
        '会员中心': 'Mitgliederbereich',
        '当前方案': 'Aktueller Plan',
        'Pro 会员': 'Pro-Mitgliedschaft',
        '专业创作者首选': 'Erste Wahl für professionelle Ersteller',
        '月': 'Monat',
        '会员有效期': 'Mitgliedschaftsgültigkeit',
        '剩余天数': 'Verbleibende Tage',
        '续费会员': 'Mitgliedschaft verlängern',
        '取消订阅': 'Abonnement kündigen',
        '本月使用情况': 'Nutzung diesen Monat',
        '视频生成': 'Video-Generierung',
        '次': 'Mal',
        '额度使用': 'Kontingentnutzung',
        '快速生成': 'Schnellgenerierung',
        '升级方案': 'Plan upgraden',
        '联系销售': 'Vertrieb kontaktieren',
        '会员权益': 'Mitgliedervorteile',
        '续费后将延长会员有效期30天': 'Die Verlängerung verlängert die Mitgliedschaft um 30 Tage',
        '取消': 'Abbrechen',
        '确认续费': 'Verlängerung bestätigen',
        '取消后您将失去所有会员权益': 'Nach der Kündigung verlieren Sie alle Mitgliedervorteile, das Restkontingent bleibt erhalten',
        '再想想': 'Nochmal überlegen',
        '确认取消': 'Kündigung bestätigen',
        '姓名': 'Name',
        '请输入您的姓名': 'Bitte geben Sie Ihren Namen ein',
        '请输入姓名': 'Bitte geben Sie den Namen ein',
        '公司': 'Firma',
        '请输入公司名称': 'Bitte geben Sie den Firmennamen ein',
        '邮箱': 'E-Mail',
        '请输入邮箱地址': 'Bitte E-Mail-Adresse eingeben',
        '请输入邮箱': 'Bitte E-Mail eingeben',
        '请输入正确的邮箱格式': 'Bitte geben Sie ein gültiges E-Mail-Format ein',
        '需求': 'Anfrage',
        '请描述您的需求': 'Bitte beschreiben Sie Ihre Anfrage',
        '提交': 'Absenden',
        '请填写需求': 'Bitte geben Sie die Anfrage ein',
        '续费成功': 'Verlängerung erfolgreich! Mitgliedschaft wurde verlängert',
        '已取消订阅': 'Abonnement gekündigt, die Mitgliedschaft endet nach Ablauf',
        '提交成功': 'Erfolgreich gesendet, wir werden uns bald bei Ihnen melden!',
    },
    Task: {
        '生成任务': 'Generierungsaufgaben',
        '新建任务': 'Neue Aufgabe',
        '进行中': 'In Bearbeitung',
        '已完成': 'Abgeschlossen',
        '失败': 'Fehlgeschlagen',
        '队列中': 'In Warteschlange',
        '活跃任务': 'Aktive Aufgaben',
        '刷新': 'Aktualisieren',
        '暂无活跃任务': 'Keine aktiven Aufgaben',
        '预计剩余': 'Voraussichtlich verbleibend',
        '暂停': 'Pausieren',
        '继续': 'Fortsetzen',
        '取消': 'Abbrechen',
        '最近完成': 'Kürzlich abgeschlossen',
        '查看全部': 'Alle anzeigen',
        '暂无完成的任务': 'Keine abgeschlossenen Aufgaben',
        '播放': 'Abspielen',
        '下载': 'Herunterladen',
        '分享': 'Teilen',
        '确认取消': 'Abbruch bestätigen',
        '确定要取消任务吗': 'Möchten Sie die Aufgabe wirklich abbrechen',
        '已消耗的额度将无法退还': 'Verbrauchtes Kontingent kann nicht erstattet werden',
        '返回': 'Zurück',
        '分享作品': 'Werk teilen',
        '复制链接': 'Link kopieren',
        '任务列表已刷新': 'Aufgabenliste aktualisiert',
        '已暂停': 'Pausiert',
        '生成中': 'Generierung läuft',
        '已恢复': 'Fortgesetzt',
        '任务已取消': 'Aufgabe abgebrochen',
        '链接已复制到剪贴板': 'Link in die Zwischenablage kopiert',
    },
    VideoShow: {
        '示例': 'Beispiele',
        '来自我们演示库的一套精心挑选的剪辑片段，点击任何卡片即可开始生成与之风格相似的素材。': 'Eine sorgfältig ausgewählte Sammlung von Clips aus unserer Demo-Bibliothek. Klicken Sie auf eine beliebige Karte, um mit der Generierung von Inhalten im ähnlichen Stil zu beginnen.',
        '全部': 'Alle',
        '电影感': 'Filmisch',
        '角色': 'Figuren',
        '产品': 'Produkte',
        '自然': 'Natur',
        '趣味': 'Unterhaltsam',
        '加载中': 'Lädt',
        '暂无展示': 'Keine Demos verfügbar',
        '视频预览': 'Videovorschau',
    },
    Request: {
        '加载中': 'Laden...',
        '您已退出登录': 'Sie wurden abgemeldet. Sie können sich erneut anmelden.',
        '确认退出': 'Abmeldung bestätigen',
        '重新登录': 'Erneut anmelden',
        '错误': 'Fehler',
        '网络错误': 'Netzwerkfehler',
        '下载中': 'Herunterladen...'
    },
    Other: {
        '剩余额度': 'Restguthaben',
        '去登录': 'Anmelden',
        '请登录后查看': 'Bitte melden Sie sich an, um dies anzuzeigen',
        '任务': 'Aufgabe',
        '可在「生成任务」中查看详情': ', Details können Sie unter „Generierungsaufgaben“ einsehen',
        '查看详情': 'Details anzeigen',
        '排队中': 'In der Warteschlange',
        '运行中': 'In Bearbeitung',
        '取消': 'Abbrechen',
        '成功': 'Erfolg',
        '失败': 'Fehlgeschlagen',
        '超时': 'Zeitüberschreitung',
        '最后更新': 'Letzte Aktualisierung:',
        '视频生成': 'Video-Generierung',
        '活跃用户': 'Aktive Benutzer',
        '用户评分': 'Benutzerbewertung',
        '万': 'Tausend',
        '快速生成': 'Schnelle Generierung',
        '先进的AI模型': 'Fortschrittliche KI-Modelle, die in wenigen Minuten hochwertige Videos generieren',
        '多种风格': 'Mehrere Stile',
        '多种风格任您选择': 'Realistisch, Anime, künstlerisch und mehr – ganz nach Ihrer Wahl',
        '高清输出': 'HD-Ausgabe',
        '支持4K超高清视频输出': 'Unterstützt 4K Ultra-HD-Videoausgabe mit gestochen scharfen Details',
        '商用授权': 'Kommerzielle Lizenz',
        '生成的视频可用于商业用途': 'Generierte Videos können für kommerzielle Zwecke genutzt werden, keine Bedenken bezüglich Urheberrechten',
        '原价': 'Ursprünglicher Preis',
        '积分价格说明': 'Erläuterung der Punktpreise',
        '系列': 'Serie',
        '模型': 'Modell',
        '分辨率': 'Auflösung',
        '积分': 'Punkte',
        '秒': 'Sekunde',
        '秒示例': 'Sekunden (Beispiel)',
        '图片模型': 'Bildmodell',
        '图片为': 'Bild ist',
        '系列产品': 'Serienprodukte, aktuell unterstützt',
        '支持使用任意机型查看完整体验': ', unterstützt die Nutzung beliebiger Geräte für das vollständige Erlebnis.',
        '计费方式': 'Abrechnungsmethode',
        '张': 'Bild',
        '按生成张数计费': 'Abrechnung nach Anzahl der generierten Bilder',
        '普通用户': 'Normaler Benutzer',
        '无记录': 'Keine Aufzeichnungen',
        '总支出': 'Gesamtausgaben',
        '月总使用': 'Monatliche Gesamtnutzung',
        '月视频使用': 'Monatliche Video-Nutzung',
        '月图片使用': 'Monatliche Bild-Nutzung',
        '生成成功': 'Generierung erfolgreich',
        '视频总生成': 'Videos insgesamt generiert',
        '图片总生成': 'Bilder insgesamt generiert',
        '生成中': 'Generierung läuft, bitte 1-3 Minuten warten',
        '来自我们演示库的一套精心挑选的剪辑片段': 'Eine sorgfältig ausgewählte Sammlung von Clips aus unserer Demo-Bibliothek.',
        '最近7天': 'Letzte 7 Tage',
        '最近30天': 'Letzte 30 Tage',
        '本月': 'Dieser Monat',
        '上月': 'Letzter Monat',
        '选择支付方式': 'Zahlungsmethode wählen',
        '确认支付': 'Zahlung bestätigen'
    }
}